var map = {
	"./99acres.png": 23068,
	"./excel.png": 15205,
	"./gmail.png": 87270,
	"./google.png": 43635,
	"./googlecalender.png": 12845,
	"./googlecontacts.png": 73436,
	"./googleforms.png": 69718,
	"./googlesheets.png": 25483,
	"./indiamart.png": 53825,
	"./justdial.png": 23502,
	"./leadform.png": 97442,
	"./magicbricks.png": 32083,
	"./razorpay.png": 16928,
	"./tradeIndia.png": 63997,
	"./typeform.png": 66820,
	"./word.png": 16994,
	"./wordpress.png": 69773
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64893;